<template>

  <tr>
    <td>
      {{item.q_1}}
    </td>
    <td>{{item.q_2}}</td>
    <td>{{ item.price }}</td>
    <td>{{ item.offer }}</td>
    <td>
      <b-badge class="mx-1 cursor_pointer rounded-pill" @click="removeBulk(item)">حذف</b-badge>
      <b-badge v-b-modal="`update-bulk-${item.id}`" class="mx-1 cursor_pointer rounded-pill">ویرایش</b-badge>
    </td>

    <b-modal :id="`update-bulk-${item.id}`" hide-footer>
      <div class="text-right">
        <bulk-form :bulk="item"  :product_id="item.product_id"/>
      </div>
    </b-modal>


  </tr>

</template>

<script>
import BulkForm from "./BulkForm";

export default {
  name: "BulkItem",
  components: {BulkForm},
  props: {
    item: {}
  },
  methods: {
    removeBulk(bulk) {
      if (confirm("از حذف ایتم اطمینان دارید؟")) {
        this.$store.dispatch('Bulk/deleteBulk', bulk)
      }
    }
  }
}
</script>

<style scoped>
.cursor_pointer {
  cursor: pointer;
}
</style>